export const GENERATE_USER_SESSION_ID = 'GENERATE_USER_SESSION_ID';
export const STOP_USER_TO_PURCHASE = 'STOP_USER_TO_PURCHASE';
export const RESET_STOP_USER_TO_PURCHASE = 'RESET_STOP_USER_TO_PURCHASE';

export const actionGenerateUserSessionID = (dispatch) => {
    dispatch({ type: GENERATE_USER_SESSION_ID });
};

export const actionStopUserToPurchase = (dispatch) => {
    dispatch({ type: STOP_USER_TO_PURCHASE });
};

export const actionResetStopUserToPurchase = (dispatch) => {
    dispatch({ type: RESET_STOP_USER_TO_PURCHASE });
};